import { BigTitle } from 'shared/components/BigTitle';
import { Block } from 'shared/components/Block';
import { Description } from 'shared/components/Description';
import { Wrapper } from 'shared/components/Wrapper';
import { NBSP } from 'shared/constants/symbols';
import * as styles from './styles.css';
import { LIST } from './constants';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export const AboutVerticals: React.FC = () => {
  const device = useDeviceType();

  return (
    <div>
      <Wrapper withoutPaddingBottom>
        <Block>
          <BigTitle text="Про вертикали" />
          <Description
            text={[
              {
                value: `Мы развиваем бизнес по${NBSP}диверсифицированной модели, сочетая разные источники выручки и${NBSP}направления с${NBSP}разной динамикой роста. Вместе эти вертикали создают сбалансированную модель, которая помогает Циан развиваться стабильно и${NBSP}предсказуемо.`,
              },
            ]}
          />
          <div className={clsx(styles['list'], styles[device])}>
            {LIST.map(({ title, percent, segments, keyClients, url }, key) => (
              <div key={key} className={styles['item']}>
                <a href={url}>
                  <div className={styles['item-title']}>{title}</div>
                </a>
                <div className={styles['percent-container']}>
                  <div className={styles['percent']}>
                    ~{percent}
                    <span className={styles['symbol']}>%</span>
                  </div>
                  <div className={styles['percent-text']}>от общей выручки Циан</div>
                </div>
                <div className={styles['chips']}>
                  <div className={styles['chips-title']}>Сегменты:</div>
                  <div className={styles['chips-list']}>
                    {segments.map((segment, segKey) => (
                      <div key={segKey} className={styles['chip']}>
                        {segment}
                      </div>
                    ))}
                  </div>
                </div>
                <div className={styles['chips']}>
                  <div className={styles['chips-title']}>Ключевые клиенты:</div>
                  <div className={styles['chips-list']}>
                    {keyClients.map((clientKey, clientsIndex) => (
                      <div key={clientsIndex} className={styles['chip']}>
                        {clientKey}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Block>
      </Wrapper>
    </div>
  );
};
